import React from "react";
import { useDispatch } from "react-redux";
import clsx from "clsx";
import { get } from "lodash";

import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import RemoveRiskIcon from "@material-ui/icons/RemoveCircle";

import IColumn from "interfaces/Column";
import { setRiskCandidateForDeletion } from "store/actions/vetHorseDetailsPage";
import { TListItem } from "../ListTable";

import useStyles from "./styles";

interface IProps {
  rowItem: TListItem;
  columns: IColumn[];
  isAlertItemPredicate: (item: TListItem) => boolean;
  commentsSource: string[];
  getRemoveItemButtonShowingRules: (
    item: TListItem,
    columnIndex: number
  ) => boolean;
}

const ListRow = (props: IProps) => {
  const {
    rowItem,
    columns,
    isAlertItemPredicate,
    commentsSource,
    getRemoveItemButtonShowingRules
  } = props;

  const classes = useStyles();
  const dispatch = useDispatch();

  const handleOpenRemoveCustomRiskPopup = () => {
    dispatch(setRiskCandidateForDeletion(rowItem));
  };

  const comments = commentsSource.map(
    commentField =>
      Boolean(rowItem[commentField]?.trim().length) && (
        <div key={`${rowItem.id}${commentField}`} className={classes.note}>
          {rowItem[commentField]}
        </div>
      )
  );

  return (
    <>
      <TableRow
        className={clsx(classes.tableRow, {
          [classes.alert]: isAlertItemPredicate(rowItem)
        })}
      >
        {columns.map((column, index) => (
          <TableCell
            key={`${rowItem.id}${column.id}`}
            className={clsx(classes.tableCell)}
            style={{ width: column.width }}
          >
            {column.renderer
              ? column.renderer(get(rowItem, column.field))
              : get(rowItem, column.field) || "-"}
            {getRemoveItemButtonShowingRules(rowItem, index) && (
              <IconButton
                className={classes.removeRiskButton}
                onClick={handleOpenRemoveCustomRiskPopup}
              >
                <RemoveRiskIcon className={classes.removeIcon} />
              </IconButton>
            )}
          </TableCell>
        ))}
      </TableRow>

      {Boolean(commentsSource.length) && (
        <TableRow>
          <TableCell className={classes.tableComment} colSpan={columns.length}>
            {comments}
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default React.memo(ListRow);
